var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"result hr",attrs:{"fluid":""}},[_c('v-row',{staticClass:"mb-2"},[_c('h3',{staticClass:"result-title"},[_vm._v(_vm._s(_vm.background.title))])]),_c('v-row',[_c('button',{staticClass:"mt-0 mb-4 button-detail",on:{"click":function($event){return _vm.onClick.call(this)}}},[_vm._v(" Read More ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }